import {
  createContext,
  useReducer,
  useContext,
  ReactNode,
  Dispatch,
} from 'react';

import flightSearchBarReducer from './reducer';
import { initialState, IFlightSearchBarState } from './state';
import { FlightSearchBarActions } from './actions';

interface IFlightSearchBarProvider {
  children?: ReactNode;
}

const FlightSearchBarContext = createContext<{
  state: IFlightSearchBarState;
  dispatch: Dispatch<FlightSearchBarActions>;
}>({
  state: initialState,
  dispatch: () => null,
});

export const FlightSearchBarProvider = ({
  children,
}: IFlightSearchBarProvider) => {
  const [state, dispatch] = useReducer(flightSearchBarReducer, initialState);

  return (
    <FlightSearchBarContext.Provider value={{ state, dispatch }}>
      {children}
    </FlightSearchBarContext.Provider>
  );
};

const useFlightSearchBar = () => {
  const context = useContext(FlightSearchBarContext);

  if (context === undefined) {
    throw new Error(
      'useFlightSearchBar must be used within FlightSearchBarContext'
    );
  }

  return context;
};

export default useFlightSearchBar;
